export default __webpack_public_path__ + "static/media/submenu_6_off.f2d58bd3.svg";